import React from 'react';
import { Outlet } from 'react-router-dom';

const FeedsLayout = () => {
  return <Outlet />;
};

export default FeedsLayout;
